import { ChangeDetectionStrategy, ChangeDetectorRef, Component, isDevMode, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterOutlet } from '@angular/router';
import { FuseHorizontalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { UserComponent } from 'app/layout/common/user/user.component';
import { OutstandingActionsComponent } from 'app/layout/common/outstanding-actions/outstanding-actions.component';
import { Subject, takeUntil } from 'rxjs';
import { SettingThemeService } from 'app/shared/services/setting-theme.service';
import { SettingTheme } from 'app/shared/types/setting-theme-type';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'dante-tutor-layout',
    templateUrl: './dante-tutor.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        FuseHorizontalNavigationComponent,
        MatButtonModule,
        MatIconModule,
        UserComponent,
        OutstandingActionsComponent,
        RouterOutlet,
        RouterLink
    ]
})
export class DanteTutorLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    settingTheme: SettingTheme;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _themeService: SettingThemeService,
        private _changeDetectorRef: ChangeDetectorRef
    ) { }

    get currentYear(): number {
        return new Date().getFullYear();
    }

    ngOnInit(): void {
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                this.isScreenSmall = !matchingAliases.includes('md');
            });

        this._themeService.getSettingTheme()
            .subscribe((settingTheme: SettingTheme) => {
                this.settingTheme = settingTheme;
                this.settingTheme.logo = '/content/images/' + settingTheme.logo;
                if (isDevMode()) {
                    this.settingTheme.logo = 'https://andrew.miniplanner.dev' + this.settingTheme.logo;
                }
                this._changeDetectorRef.detectChanges();
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
